export const REDFIN_ALLOWED_PRODUCTS = [
  2731, // Furniture Removal & Virtual Staging 
  616, // Virtual Staging
  2724 // Wall Paint Color Change
];